import React from "react";
import AccountLayout from "../layouts/AccountLayout/AccountLayout";
import CampaignsManagerContainer from "../features/campaigns/containers/CampaignsManagerContainer";

const ProposalsManagerView = (props) => {
  return (
    <AccountLayout>
      <CampaignsManagerContainer {...props} variant="proposals" />
    </AccountLayout>
  );
};

export default ProposalsManagerView;
